import { render, staticRenderFns } from "./folders-vessels.vue?vue&type=template&id=623aedcc&scoped=true"
import script from "./folders-vessels.vue?vue&type=script&lang=js"
export * from "./folders-vessels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623aedcc",
  null
  
)

export default component.exports